import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from '../../shared/logger.service';

@Component({
  selector: 'app-test-route-param',
  standalone: true,
  imports: [],
  templateUrl: './test-route-param.component.html',
  styleUrl: './test-route-param.component.scss'
})
export class TestRouteParamComponent {

  public paramId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private logger: LoggerService
  ) {
    this.route.paramMap.subscribe(params => {
      if (params)
        this.paramId = params.get('id');
      this.logger.debug(`params:id:`, params.get('id'));
    })
  }
}
